/*
 One component per logo — `<svg mib-logo-ai>`, `<svg mib-logo-mark-io>` — each reaching a single
 definition, so an application ships the drawings it names and nothing else.

 GENERATED from `scripts/logos.manifest.json` — do not edit. Regenerate with:

   node scripts/generate-logos.mjs

 They are the way to draw a logo. `[mib-logo]` remains for the one case they cannot cover — a mark
 chosen at runtime — and costs all 10 drawings, since a name can only be resolved against the
 whole table.

 Nothing here may import `MIB_LOGO_DATA`: naming the table is what pins every logo into the bundle,
 and it would undo the split. The base class lives in `logo.models.ts` for that reason, and the
 template beside this file is a copy of `logo.component.html`, written by the generator.
*/
import { Component, signal } from '@angular/core';

import { MIB_LOGO_CLASS } from '../logo.models';
import {
  MIB_LOGO_MEDINBOX,
  MIB_LOGO_AI,
  MIB_LOGO_IO,
  MIB_LOGO_LI,
  MIB_LOGO_PI,
  MIB_LOGO_MARK_AI,
  MIB_LOGO_MARK_IO,
  MIB_LOGO_MARK_LI,
  MIB_LOGO_MARK_PI,
  MIB_LOGO_SYMBOL,
} from '../logo.data';

/** The `medinbox` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-medinbox]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'medinbox'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoMedinboxComponent {
  protected readonly definition = signal(MIB_LOGO_MEDINBOX).asReadonly();
}

/** The `ai` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-ai]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'ai'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoAiComponent {
  protected readonly definition = signal(MIB_LOGO_AI).asReadonly();
}

/** The `io` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-io]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'io'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoIoComponent {
  protected readonly definition = signal(MIB_LOGO_IO).asReadonly();
}

/** The `li` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-li]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'li'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoLiComponent {
  protected readonly definition = signal(MIB_LOGO_LI).asReadonly();
}

/** The `pi` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-pi]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'pi'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoPiComponent {
  protected readonly definition = signal(MIB_LOGO_PI).asReadonly();
}

/** The `mark-ai` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-mark-ai]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'mark-ai'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoMarkAiComponent {
  protected readonly definition = signal(MIB_LOGO_MARK_AI).asReadonly();
}

/** The `mark-io` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-mark-io]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'mark-io'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoMarkIoComponent {
  protected readonly definition = signal(MIB_LOGO_MARK_IO).asReadonly();
}

/** The `mark-li` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-mark-li]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'mark-li'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoMarkLiComponent {
  protected readonly definition = signal(MIB_LOGO_MARK_LI).asReadonly();
}

/** The `mark-pi` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-mark-pi]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'mark-pi'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoMarkPiComponent {
  protected readonly definition = signal(MIB_LOGO_MARK_PI).asReadonly();
}

/** The `symbol` logo, and only its geometry. */
@Component({
  selector: 'svg[mib-logo-symbol]',
  templateUrl: './logo-variants.component.html',
  host: {
    '[attr.data-logo]': "'symbol'",
    '[attr.viewBox]': 'definition().viewBox',
    class: MIB_LOGO_CLASS,
  },
})
export class MibLogoSymbolComponent {
  protected readonly definition = signal(MIB_LOGO_SYMBOL).asReadonly();
}
